function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function stripApiSuffix(value: string): string {
  return value.replace(/\/api(?:\/v1)?$/, '')
}

const rawApiUrl = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8000'
const backendBaseUrl = stripApiSuffix(stripTrailingSlash(rawApiUrl))

export const backendUrl = backendBaseUrl
export const apiBaseUrl = `${backendBaseUrl}/api/v1`
